import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H5Props = Omit<HeadingProps, 'tagName'>;

const H5 = styled(Heading).attrs({
  tagName: 'h5',
})``;

H5.displayName = 'H5';

export default H5;
